"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPane = exports.Tabs = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const tabs_1 = tslib_1.__importDefault(require("antd/es/tabs"));
exports.Tabs = (_a) => {
    var { className = '', animated = false } = _a, props = tslib_1.__rest(_a, ["className", "animated"]);
    return React.createElement(tabs_1.default, Object.assign({ animated: animated, className: `clp-tabs ${className}` }, props));
};
exports.TabPane = tabs_1.default.TabPane;
//# sourceMappingURL=Tabs.js.map